type MeasureText = (text: string) => number;

const NON_BREAKING_SPACE = '\u2060';

export abstract class MultiLineFont {
  splitText(
    measureText: MeasureText,
    text: string,
    maxWidth: number,
    lang: Intl.LocalesArgument
  ): string[] {
    let res: string[] = [];

    const lines: string[] = text.split('\r\n');

    try {
      if (!lang) {
        throw new Error('Language is required');
      }

      const segmenter = new Intl.Segmenter(lang, { granularity: 'word' });
      res = this.splitTextBySegments(segmenter, measureText, maxWidth, lines);
    } catch {
      res = this.splitTextByWords(measureText, maxWidth, lines);
    }

    res = res.map((line) => {
      if (line.includes(NON_BREAKING_SPACE)) {
        return line.replaceAll(NON_BREAKING_SPACE, ' ');
      }
      return line;
    });

    return res;
  }

  private splitTextByWords(measureText: MeasureText, maxWidth: number, lines: string[]): string[] {
    const result: string[] = [];
    lines.forEach((text) => {
      const words: string[] = text.split(' ');

      let line = '';
      const wordsLengthMinusOne = words.length - 1;

      for (let n = 0; n < words.length; n++) {
        const testLine = line + words[n] + (n < wordsLengthMinusOne ? ' ' : '');
        const width = measureText(testLine);

        if (maxWidth > 0 && width > maxWidth && n > 0) {
          result.push(line);
          line = words[n] + ' ';
        } else {
          line = testLine;
        }
      }

      if (line.endsWith(' ')) {
        line = line.substring(0, line.length - 1);
      }

      result.push(line);
    });
    return result;
  }

  private splitTextBySegments(
    segmenter: Intl.Segmenter,
    measureText: MeasureText,
    maxWidth: number,
    lines: string[]
  ): string[] {
    const result: string[] = [];
    lines.forEach((text) => {
      const words = [...segmenter.segment(text)].map((s) => s.segment);
      let line: string[] = [];

      words.forEach((lastWord) => {
        const checkLine = [...line, lastWord];
        const width = measureText(checkLine.join(''));

        if (maxWidth > 0 && width > maxWidth) {
          if (lastWord.length === 1 && /^\p{P}$/u.test(lastWord)) {
            const newLine = checkLine.slice(0, checkLine.length - 2);

            result.push(newLine.join('').trim());

            line = [checkLine[checkLine.length - 2], checkLine[checkLine.length - 1]];

            return;
          }
          result.push(line.join('').trim());
          line = [lastWord];
          return;
        }

        line.push(lastWord);
      });

      result.push(line.join('').trim());
    });
    return result;
  }
}
